import React, { FC } from 'react';
import { useTheme } from '../../../../../../../theme';
import cn from 'classnames';
import { Money as MoneyType } from '../../../../../../../types';
import Money from '../../../../../../../Money/components/Money';
import { useTranslation } from 'react-i18next';
import PriceInMiles from '../../../../../../../PriceInMiles/PriceInMiles';

interface Props {
	className?: string;
	title: string;
	disabled?: boolean;
	price: MoneyType;
	originalPrice?: MoneyType;
	priceInMiles?: number;
	disabledForMiles?: boolean;
}

const Header: FC<Props> = ({ className, title, disabled, price, originalPrice, priceInMiles }) => {
	const { t } = useTranslation('FareGroup');
	const { Header: css } = useTheme('Entities').FareGroupV2;

	const showMiles = !disabled && priceInMiles;
	const showPrice = !disabled && !priceInMiles;
	const showOriginalPrice = !!originalPrice && originalPrice.amount !== price.amount;

	return (
		<div className={cn(css.root, className)}>
			<div className={css.title}>{title}</div>

			<div className={css.right}>
				{disabled && <span className={css.unavailable}>{t('Unavailable')}</span>}

				{showMiles && (
					<PriceInMiles
						moneyClassName={css.miles}
						amountClassName={css.miles__amount}
						amount={priceInMiles}
					/>
				)}

				{showPrice && (
					<div className={css.priceWrapper}>
						<Money moneyClassName={css.price} money={price} />
						{showOriginalPrice && <Money moneyClassName={css.originalPrice} money={originalPrice} />}
					</div>
				)}
			</div>
		</div>
	);
};

export default Header;
